// import * as Yup from "yup";
// import { Formik, Field, Form } from "formik";
import classnames from "classnames";
import { inject, observer } from 'mobx-react';
import React, { Component, Fragment } from "react";
import { Download } from "react-feather";
import PerfectScrollbar from "react-perfect-scrollbar";
import { withRouter } from "react-router";
import Select from "react-select";
import { Button, Col, FormGroup, Input, Label, Row, Spinner, Alert , Progress} from "reactstrap";
import Chip from "../../theme/@vuexy/chips/ChipComponent";
import LibraryCarousel from "./components/libraryCarousel";
import UploadPreview from './components/UploadPreview';
import InputText from '../common/InputText';
import processingImg from '../../assets/img/pages/maintenance.png';
import '../../assets/scss/pages/app-library.scss';
import InputSelect from "../common/InputSelect";

@inject('libraryStore', 'templateStore')
@observer
class EditContent extends Component {
  state = {
    previewData: [],
    inputTags: '',
    file: null,
  }

  componentDidUpdate = prevProps => {
    const { pages } = this.props.libraryStore.document;
    if (pages && pages.length) {
      if (prevProps.libraryStore.document.pages !== this.state.previewData) {
        this.setState({
          previewData: prevProps.libraryStore.document.pages,
        })
      }
    }
  }

  handleSubmit = () => {
    let { libraryStore } = this.props;
    libraryStore.saveDocument();
    //this.props.handleSidebar(false);
    //this.props.closeDetailspage();
  }

  onChange = event => {
    const { libraryStore } = this.props;
    let value = event.target.value;
    if (event.target.name == 'img') {
      const file = event.target.files[0];
      /*this.setState({
        file: file
      });*/
      libraryStore.setFileAttribute({file: file});
    }
    else {
      const key = event.target.name;
      const obj = {};
      obj[key] = value;
      libraryStore.setAttribute(obj);
    }
  }

  updateFileInfo = (data) => {
    let { libraryStore } = this.props;
    if (data) {
      libraryStore.setFileAttribute(data);
    }
  }

  onSelectChange = (value, attrName) => {
    const { libraryStore } = this.props;
    const obj = {};
    obj[attrName] = value;
    libraryStore.setAttribute(obj);
  }

  changeThumbnail = (link, thumbPageNo) => {
    const { libraryStore } = this.props;
    libraryStore.setAttribute("thumbUrl", link);
    libraryStore.setAttribute("thumbPageNo", thumbPageNo);
  }

  onButtonToggle = event => {
    const { libraryStore } = this.props;
    let value = event.target.checked;
    const key = event.target.name;
    const obj = {};
      obj[key] = value;
    libraryStore.setAttribute(obj);
  }

  addTag = tag => {
    const { libraryStore } = this.props;
    libraryStore.addTag(tag)
    this.setState({ inputTags: '' });
  }

  pills = (tags = []) => {
    return (
      tags.length ? tags.map((tag, i) =>
        <Chip className="mr-1" text={tag} closable key={i}
          onClick={(e) => this.removeTag(i)}
        />
      ) : null
    );
  }

  render() {
    const { inputTags, previewData } = this.state;
    const { show, handleSidebar, editable, libraryStore } = this.props;
    const { templateList, customerStageList, contentTypeList, docCategoryList, errors, screen, fileObject } = libraryStore;
 //   const totalImages = previewData.length;
    const {
      name, description, category, tags, coverTemplate,
      contentType, shareable, isActive, readTime,
      customerStage, file
    } = libraryStore.document;
    const { conversionStatus, pages, size, docUrl, thumbUrl } = file;
    

    const uploadButton = 
        screen.create.isUploading || screen.edit.isUploading
          ? <div className="d-flex justify-content-end align-items-center mt-2">
            <Spinner color="primary" />
          </div>
          : <div className="d-flex justify-content-end align-items-center mt-2">
            <label
              className="btn btn-primary"
              htmlFor="upload-image"
              color="primary">
              Upload Document
              <input
                type="file"
                accept='application/pdf'
                name="img"
                id="upload-image"
                hidden
                onChange={e => this.onChange(e)}
              />
            </label>
          </div>

    const renderForm = 
        <React.Fragment>
          <InputText
            id="name"
            label="Name"
            name="name"
            placeholder="Document Name"
            value={name}
            error={errors.name}
            onChange={e => this.onChange(e)}
          />
          <InputText
            type="textarea"
            id="description"
            label="Description"
            name="description"
            value={description}
            rows={6}
            onChange={e => this.onChange(e)}
            placeholder="Description"
            error={errors.description}
            />

          <InputSelect
            name="category"
            optionList={docCategoryList}
            value={category}
            valueAttr="categoryCode"
            labelAttr="name"
            onSelect={this.onSelectChange}
            label="Select Category"
            id="category"
            placeholder="Select a Category"
            showRequired={true}
            error={errors.category}
          />

          <InputSelect
            name="coverTemplate"
            optionList={templateList}
            value={coverTemplate}
            valueAttr="uid"
            labelAttr="title"
            onSelect={this.onSelectChange}
            label="Select Cover Page Template"
            id="coverTemplate"
            placeholder="Select a Cover Page Template"
            showRequired={false}
            error={errors.coverTemplate}
          />

          <InputSelect
            name="contentType"
            optionList={contentTypeList}
            value={contentType}
            valueAttr="value"
            labelAttr="name"
            onSelect={this.onSelectChange}
            label="Select Content Type"
            id="contentType"
            placeholder="Select a Content Type"
            showRequired={false}
            error={errors.contentType}
          />

          <div className="d-flex justify-content-between align-items-center">
            <div style={{ width: "60%", marginRight: '5px'}}>
              <InputSelect
                name="customerStage"
                optionList={customerStageList}
                value={customerStage}
                valueAttr="value"
                labelAttr="name"
                onSelect={this.onSelectChange}
                label="Select Customer Stage"
                id="customerStage"
                placeholder="Select a Customer Stage"
                showRequired={false}
                error={errors.customerStage}
              />
            </div>
            <label>
              Read Time (in mins)
              <InputText
                id="read-time"
                name="readTime"
                value={readTime}
                error={errors.readTime}
                onChange={e => this.onChange(e)}
              />
            </label>
            {/* <InputText
                id="name"
                label="Read Time"
                name="readTime"
                value={readTime}
                error={errors.readTime}
                onChange={e => this.onChange(e)}
            /> */}
          </div>
          <div className="d-flex justify-content-around align-items-center">
            <FormGroup>
              <div className="checkbox switcher">
                <label htmlFor="isActive">
                  <input
                    type="checkbox"
                    id="isActive"
                    checked={isActive ? true : false}
                    onChange={(e) => this.onButtonToggle(e)}
                    value={isActive}
                    name="isActive" />
                  <span><small></small></span>
                  <span>Active</span>
                </label>
              </div>
            </FormGroup>
            <FormGroup>
              <div className="checkbox switcher">
                <label htmlFor="shareable">
                  <input
                    type="checkbox"
                    id="shareable"
                    checked={shareable ? true : false}
                    name="shareable"
                    onChange={(e) => this.onButtonToggle(e)}
                    value={shareable} />
                  <span><small></small></span>
                  <span>Shareable</span>
                </label>
              </div>
            </FormGroup>
          </div>
          <FormGroup>
            <Label htmlFor="keywords">Tags</Label>
            <Input
              type="text"
              value={inputTags}
              onChange={(e) => this.setState({ inputTags: e.target.value })}
              id="keywords"
              placeholder="Type keywords and hit enter"
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  if (e.target.value)
                    this.addTag(e.target.value);
                }
              }}
            />
            <div className="mt-1">
              {this.pills(tags)}
            </div>
          </FormGroup>
            </React.Fragment>

    const renderImageSection = 
        <div className="fileSection">
          <div style={{ minHeight: "300px" }}>
          {errors.fileName && <Alert color="danger">
                  <div className="alert-heading">Error</div>
                  {errors.fileName}
                </Alert>
            }
            { screen.create.isUploading &&
              <Progress className="progress-lg" value={screen.create.uploadingPercent} color="info">
                {screen.create.uploadingPercent}%
              </Progress>
            }
            {
              pages && pages.length && this.state.file == null ?
                (
                  conversionStatus == "COMPLETED" ?
                    (
                      <Fragment>
                        <LibraryCarousel
                          data={previewData}
                          // fileName={fileName}
                          name="thumbUrl"
                          contentType={contentType}
                          changeThumbnail={(link, thumbPageNo) => { this.changeThumbnail(link, thumbPageNo) }}
                          showThumbnailButton={true} />
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <Download size={20}></Download>
                            <label>Size : {(size * 0.000001).toFixed(2)} MB</label>
                          </div>
                          <div>
                            <label
                              className="btn btn-primary"
                              htmlFor="update-image"
                              color="primary">
                              Select Document
                              <input
                                type="file"
                                accept='application/pdf'
                                id="update-image"
                                name="img"
                                hidden
                                onChange={e =>
                                  this.onChange(e)
                                }
                              />
                            </label>
                          </div>
                        </div>
                      </Fragment>
                    ) : (
                      <Fragment>
                        <div className="d-flex flex-column align-items-center justify-content-center theme-bg-img" style={{ height: "auto", border: "2px dashed #eee" }}>
                          <img
                            className="img-fluid overflow-hidden-preview-img"
                            src={processingImg}
                            alt={"processing"}
                          />
                          <span>
                            <h2 className="centered">Processing..</h2>
                          </span>
                        </div>

                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <Download size={20}></Download>
                            <label>Size : {(size * 0.000001).toFixed(2)} MB</label>
                          </div>
                          <div className="upload-disable">
                            <h6>Cannot upload while Processing</h6>
                          </div>
                        </div>
                      </Fragment>
                    )
                ) : (
                  <Fragment>
                    <UploadPreview file={fileObject} updateFileInfo={this.updateFileInfo} />
                    { uploadButton }
                  </Fragment>
                )
            }
          </div>
          {/* {
            conversionStatus !== "COMPLETED"
              ? 
              : null
          } */}
          {
            thumbUrl && docUrl && this.state.file == null && conversionStatus == "COMPLETED"
              ? <div className="d-flex justify-content-between align-items-center flex-wrap mt-3" style={{ width: "100%" }}>
                <div className="d-flex justify-content-center align-items-center" style={{ width: "50%", border: "1px solid #eee" }}>
                  <img src={thumbUrl} alt="thumbnail" style={{ height: "auto", width: "100%", objectFit: "contain", objectPosition: "center" }} />
                </div>
                <div className="d-flex justify-content-center align-items-center" style={{ width: "50%" }} >
                  <p className="mb-0 text-center" style={{ fontSize: "14px", color: "#cacaca" }}>Selected Thumbnail.</p>
                </div>
              </div>
              : null
          }
        </div>


    return (
      <div
        className={classnames("data-list-sidebar", {
          show: show
        })}>
        <div className="data-list-sidebar-header mt-2 px-2 d-flex justify-content-between align-items-center">
          <h4 className="mb-0">{editable ? "Edit" : "ADD"}</h4>
          <div className="data-list-sidebar-footer px-2 d-flex justify-content-start align-items-center">
            <Button color="primary" onClick={() => { this.setState({ file: null }); this.handleSubmit() }}>
              Save
            </Button>
            <Button
              className="ml-1"
              color="danger"
              outline
              onClick={() => {
                this.setState({ file: null });
                handleSidebar(false)
              }}
            >
              Cancel
            </Button>
          </div>
        </div>
        <PerfectScrollbar
          className="data-list-fields px-2 mt-3"
          options={{ wheelPropagation: false }}>
          <Row>
            <Col xs={12} md={6} lg={6}>
              {renderForm}
            </Col>
            <Col xs={12} md={6} lg={6}>
              {renderImageSection}
            </Col>
          </Row>
        </PerfectScrollbar>
      </div>
    )
  }
}

export default withRouter(EditContent);